module.exports = __webpack_public_path__ + "static/media/9DESA11.9ece8d79.jpg";